import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3e3140c0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=3e3140c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3140c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e3140c0')) {
      api.createRecord('3e3140c0', component.options)
    } else {
      api.reload('3e3140c0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3e3140c0&scoped=true&", function () {
      api.rerender('3e3140c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/suppliers/index.vue"
export default component.exports